import { render, staticRenderFns } from "./examination-view.vue?vue&type=template&id=5cd1eaac&scoped=true"
import script from "./examination-view.vue?vue&type=script&lang=js"
export * from "./examination-view.vue?vue&type=script&lang=js"
import style0 from "./examination-view.vue?vue&type=style&index=0&id=5cd1eaac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd1eaac",
  null
  
)

export default component.exports